/**
 * 康熙笔画字典（姓名学口径）—— 薄封装
 *
 * 数据源：src/data/naming/kangxi-strokes.json（由 scripts/extract-naming-data.mjs
 * 从 shunshi-kangxi-core 常用字集提取）。氵按水4画、艹按艸6画、辶按辵7画等
 * 姓名学康熙口径已由数据源保证；简体输入自动折算到繁体主键。
 *
 * 未收录的字一律返回 null（交给手动输入笔画兜底），绝不臆造数据。
 */
import kxData from '@/data/naming/kangxi-strokes.json'

/**
 * 查单字康熙笔画
 * @param {string} char 单个汉字（简/繁均可）
 * @returns {{strokes:number, wuxing:string|null, simplified:string, traditional:string}|null}
 */
export function lookupChar(char) {
  if (typeof char !== 'string' || char.length !== 1) return null
  let key = char
  if (!kxData.chars[key]) key = kxData.alias[char]
  const entry = kxData.chars[key]
  if (!entry) return null
  const [traditional, strokes, wuxing] = entry
  return { strokes, wuxing, simplified: key, traditional: traditional || key }
}

/**
 * 查整名：逐字返回康熙信息与总笔画
 * @param {string} surname 姓（单字）
 * @param {string} givenName 名（1-2字）
 * @returns {{chars:Array, total:number|null}} chars 与面板输入逐字对应，未收录项为 null
 */
export function lookupName(surname, givenName) {
  const name = `${surname || ''}${givenName || ''}`
  const chars = [...name].map((ch) => lookupChar(ch))
  const allFound = chars.every(Boolean)
  return {
    chars,
    total: allFound ? chars.reduce((a, c) => a + c.strokes, 0) : null
  }
}

export default { lookupChar, lookupName }
